SJ.Tools = {
  cookieValue(cookieName) {
    let cookies = document.cookie.split(';');

    for (let i = 0; i < cookies.length; i++) {
      if (cookieName == cookies[i].split('=')[0].split(' ').join(''))
        return cookies[i].split('=')[1];
    }

    console.log(`%c cookie "${cookieName}" does not exist`, 'color: red');
    return false;
  },

  getRandom(min, max) {
    return Math.random() * (max - min) + min;
  },

  updateSettingInDatabase(settingName, settingValue) {
    if (SJ.playerData.data['name'] === 'Guest') return;

    fetch(
      `${SJ.APILink}settings/update.php?userName=${SJ.playerData.data['name']}&settingName=${settingName}&settingValue=${settingValue}`
    );
  },
};
